import { siteStore } from "src/js/stores/site";

export const setSiteCardId = (id: string) => (siteStore.siteCardId = id);

export const clearSiteCardId = () => (siteStore.siteCardId = null);
